import Backbone from 'backbone';
import moment from 'moment';

export default Backbone.Model.extend({
  parse(response) {
    const results = response.results;
    results.endTimestamp = moment(results.endTimestamp);
    results.startTimestamp = moment(results.startTimestamp);
    return response;
  },
});
